import type { Translation } from "@/types/translationTypes"

export const en: Translation = {
  sidebar: {
    home: "Home",
    profile: "Profile",
    enrolledCourses: "Enrolled Courses",
    projects: "Projects",
    feedbacks: "Feedbacks",
    tickets: "Tickets",
    yourCv: "Your CV",
    survey: "Surveys",
    freeMaterials: "EraaSoft Library",
    isNew: "New",
    certificates: "Certificates",
  },
  freeMaterialsPage: {
    viewCourse: "View",
    enrollIntoCourse: "Enroll",
    freeCourse: "Free",
    viewPdf: "Preview Pdf",
    watchVideo: "Watch Video",
    paidMaterial: "Paid Material",
    paidMaterialToast: "This material is for paid users only",
    free: "FREE",
    completed: "completed",
    markDone: "Mark as Done",
    markNotDone: "Mark as Not Done",
    ratings: "Ratings",
    allRatings: "All Rating",
    myRating: "My Rating",
    addReview: "Add Review",
    ratingLabel: "Rating",
    commentLabel: "Comment (optional)",
    ratingToast: "You must complete at least 25% to add rating",
    delete: "Delete Review?",
  },

  advertisements: {
    title: "Special Offer",
  },

  newTicketModal: {
    subject: "Subject",
    description: "Description",
  },

  courseModalsTitles: {
    courseEdit: "Edit Course",
    courseAdd: "Add Course",
    courseDuplicate: "Duplicate Course",
    roundNotes: "Round Notes",
    mindMap: "Mind Map",
    videoModal: "Video",
    editSocialLinks: "Edit Social Links",
    editSkills: "Edit Skills",
    video: "introduction video",
  },
  socialLinksModal: {
    errors: {
      url: "Must be a valid URL",
    },
    data: {
      github: { label: "Github", placeholder: "Enter Github URL" },
      linkedin: { label: "Linkedin", placeholder: "Enter Linkedin URL" },
      behance: { label: "Behance", placeholder: "Enter Behance URL" },
      facebook: { label: "Facebook", placeholder: "Enter Facebook URL" },
      youtube: { label: "Youtube", placeholder: "Enter Youtube URL" },
      stackoverflow: {
        label: "Stackoverflow",
        placeholder: "Enter Stackoverflow URL",
      },
      devto: { label: "Dev.to", placeholder: "Enter Dev.to URL" },
    },
  },

  birthdayBanner: {
    title: "Happy Birthday!",
    message:
      " Wishing you a wonderful day filled with happiness and success!🎂",
  },
  buttons: {
    clear: "Clear",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    add: "Add",
    upload: "Upload",
    prev: "Prev",
    next: "Next",
    login: "Login",
    seeAll: "See All",
    goto: "Go to",
    ok: "OK",
    learnMore: "Learn More",
    send: "Send",
    delete: "Delete",
    logout: "Logout",
    back: "Back",
    share: "Share",
    download: "Download as Image",
    copyLink: "Copy Link",
    facebook: "Facebook",
    twitter: "Twitter",
    linkedin: "LinkedIn",
    view: "View",
    loading: "Loading...",
    generateCertificate: "Generate Certificate",
  },
  skillsModal: {
    errors: {
      exists: "Skill is required",
    },
    data: {
      skill: { placeholder: "Enter Skill" },
      noData: "No Data",
    },
  },

  newProjectModal: {
    title: "Title",
    description: "Description",
    link: "Link",
    videoLink: "Video Link",
    errors: {
      title: "Title is required",
      description: "Description is required",
      link: "Link is required",
      videoLink: "Video Link is required",
    },
  },

  NotificationModalsTitles: {
    notificationDetails: "Notification Details",
  },
  enrolledCoursesModalsTitles: {
    feedback: "Feedback",
    taskUpload: "Task Upload",
    videoPreview: "Video Preview",
    materialPreview: "Material Preview",
    lectureTasks: "Lecture Tasks",
    lectureProjects: "Lecture Projects",
    lectureContent: "Lecture Content",
    lectureMentorSessions: "Lecture Mentor Sessions",
    lectureAdditionalMaterials: "Lecture Additional Materials",
    attendLecture: "Attend Lecture",
    mindMap: "Course Plan",
  },

  taskUpload: {
    data: {
      task_url: { placeholder: "Enter Task URL", label: "Task URL" },
    },
  },

  driveVideoPreview: {
    errors: {
      invalid: "Invalid video URL",
    },
  },

  additionalMaterialsPreview: {
    errors: {
      invalid: "Invalid URL",
    },
  },

  additionalMaterials: {
    pdf: "PDF",
    video: "Video",
  },

  lectureContentModal: {
    chapter: "Chapter",
    lesson: "Lesson",
  },

  attendLecture: {
    title: "Attend Lecture",
  },
  feedbackModalTitles: {
    feedbacks: "Feedbacks",
  },
  ticketsModalTitles: {
    newTicket: "New Ticket",
  },
  projectsModalTitles: {
    addProject: "Add Ticket",
    editProject: "Edit Project",
  },

  errorPage: {
    title: "Sorry, something went wrong",
    subtitle: "Unexpected Error happened, please try again",
    buttons: {
      home: "Home page",
    },
  },

  pageTitles: {
    home: "Home",
    profile: "Profile",
    feedbacks: "Feedbacks",
    projects: "Projects",
    tickets: "Tickets",
    enrolledCourses: "Enrolled Courses",
    yourCv: "Your CV",
    surveys: "Surveys",
    answers: "Answers",
    freeMaterials: "EraaSoft Library",
    certificates: "Certificates",
  },

  surveysPage: {
    table: {
      no: "No.",
      title: "Title",
      description: "Description",
    },
    item: {
      seeAnswers: "See answers",
      answer: "Answer",
    },
  },
  surveyAnswerPage: {
    error: {
      data: "Failed to load data ❌",
      answerAll:
        "Please answer all questions before moving to the next section ⚠",
    },
    note: "Note (optional)",
    recommend: {
      message: "How much do you recommend Eraasoft?",
      low: "Don't recommend",
      high: "Highly recommend",
    },
    answerKey: {
      one: "Totally disagree",
      two: "Disagree",
      three: "Neutral",
      four: "Agree",
      five: "Totally agree",
    },
  },

  auth: {
    login: {
      title: "Login",
      subtitle: "Login to your account",
      messages: {
        success: "Logged in successfully",
      },
      data: {
        email: {
          label: "Email",
          placeholder: "Enter Email",
        },
        password: {
          label: "Password",
          placeholder: "Enter Password",
        },
      },
    },
  },

  achievementFlair: {
    roundLeaderTitle: "Congratulations! You're leading the round!",
    roundLeaderSub: "Keep up the excellent work to stay at the top.",
    topOneTitle: "Great job! You're one of our Top One students!",
    topOneSub: "Your hard work and dedication are showing results.",
    roundLeaderBadge: "Round Leader",
    topOneBadge: "Top One Student",
    shareTitle: "Share achievement",
    shareMessageRoundLeader:
      "I'm proud to share that I'm currently leading round {{group}} in the {{course}} course at EraaSoft Academy! 🏆",
    shareMessageTopOne:
      "I'm excited to share that I'm one of the Top One students in round {{group}} for the {{course}} course at EraaSoft Academy! 🌟",
  },
  topOneShare: {
    notFound: "Achievement not found",
    title: "Top One Achievement",
    academy: "EraaSoft Academy",
    course: "Course",
    round: "Round",
    verifiedBy: "Verified by EraaSoft",
  },
  homePage: {
    feedbacks: {
      title: "Feedbacks",
    },
    absenceAlert: {
      title: "Absence Alert",
      message: "You have frequent absences. Please contact the operations team",
    },
    missedTasksAlert: {
      title: "Missed Tasks Alert",
      message:
        "You have missed tasks. Please submit them as soon as possible to avoid penalties",
    },

    latestLectures: {
      title: "Latest Lectures",
      startsAt: "Starts At",
      joinNow: "Join Now",
    },
    topOne: {
      subHeading: "Top students in",
    },
    leaderboard: {
      roundRank: "Round Rank",
      lecturesDegree: "Lectures Degree",
      roundStats: {
        title: "Round Stats",
        attendancePieChartTitle: "Attendance",
        avgRatingPieChartTitle: "Task Avg",
        scorePieChartTitle: "Avg Score",
        bonusPieChartTitle: "Bonus",
        remaining: "Remaining",
      },
      barchart: {
        label: "Degree",
      },
      progress: {
        title: "Your Progress",
        progressUnder50: "Your progress under 50%",
        reachedHighestBadge: "You reached the highest badge",
        badgeNames: {
          bronze: "Bronze",
          silver: "Silver",
          gold: "Gold",
          platinum: "Platinum",
          diamond: "Diamond",
          topOne: "Top One",
        },
      },
    },
    todaysMeetings: {
      title: "Todays Meetings",
      table: {
        no: "No",
        lectureName: "Lecture Name",
        joinUrl: "Join Url",
        startAt: "Start At",
        lectureTask: "Lecture Task",
        myTask: "My Task",
        joinTooltip: "Join",
        taskTooltip: "Task Link",
        submissionTooltip: "My Submission",
      },
    },
  },

  profilePage: {
    defaults: {
      country: "Egypt",
      other: "Other",
    },
    title: "Personal Data",
    data: {
      image: "Profile Image",
      army_status: {
        label: "Army Status",
        placeholder: "Enter Army Status",
      },
      name: {
        label: "Name",
        placeholder: "Enter Name",
      },
      email: {
        label: "Email",
        placeholder: "Enter Email",
      },
      password: {
        label: "Password",
        placeholder: "Enter Password",
      },
      phone: {
        label: "Phone",
        placeholder: "Enter Phone",
      },
      birthdate: {
        label: "Birthdate",
        placeholder: "Enter Birthdate",
      },
      country: {
        label: "Country",
        placeholder: "Enter Country",
      },
      city: {
        label: "City",
        placeholder: "Enter City",
      },
      college: {
        label: "College",
        placeholder: "Enter College",
      },
      profession: {
        label: "Profession",
        placeholder: "Enter Profession",
      },
      type: {
        label: "Student / Graduate",
        placeholder: "",
      },
    },
    socialLinks: {
      title: "Social Links",
    },
    skills: {
      title: "Skills",
      noData: "No Skills Added Yet",
    },
    army_statuses: {
      in_progress: "In Progress",
      finished: "Finished",
      exempt: "Exempt",
      postponed: "Postponed",
    },
  },

  feedbacksPage: {
    title: "Feedbacks",
    table: {
      no: "No.",
      group: "Group",
      lecture: "Lecture",
      feedback: "Feedback",
    },
  },

  projectsPage: {
    title: "Projects",
    table: {
      no: "No.",
      name: "Name",
      description: "Description",
      link: "Link",
      video: "Video",
      videoTooltip: "Video Preview",
      comment: "Comments",
    },
    delete: "Delete Project",
  },

  ticketsPage: {
    title: "Tickets",
    chatShow: {
      subject: "Subject",
      description: "Description",
      micPermission:
        "Always allow Knowledge-Academy.com access to your microphone",
      content: { label: "Content", placeholder: "Add Feedback" },
      note: { label: "Note", placeholder: "Add Note" },
    },
    table: {
      no: "No.",
      name: "Name",
      subject: "Subject",
      description: "Description",
      status: "Status",
      view: "View",
      openTooltip: "Open",
    },
    statuses: {
      new: "New",
      pending: "Pending",
      inProgress: "In Progress",
      closed: "Closed",
    },
    filters: {
      all: "All",
      opened: "Open",
      closed: "Closed",
      pending: "Pending",
      inProgress: "In Progress",
    },
    delete: "Delete Ticket",
    newTicketTooltip: "Add New Ticket",
  },

  pagination: {
    data: {
      page: "Page",
    },
    errors: {
      invalidPage: "Invalid Page Number",
    },
  },

  certificates: {
    notFound: "Certificate not found",
    verifiedBy: "Verified by EraaSoft",
    shareTitle: "My Certificate",
    shareText: "I've earned a certificate in {{course}} at Eraasoft!",
    copied: "Link copied to clipboard!",
    generatedSuccess: "Certificate generated successfully!",
  },

  enrolledCoursesPage: {
    lecturesDetails: {
      lectureContent: "Lecture Content",
      deadlineNotSet: "Deadline Not Set",
      taskNotSet: "Task Not Set",
      attendance: {
        attended: "Attended",
        absent: "Absent",
        todaysLecture: "Today's Lecture",
      },
      lectureVideosTooltip: "Lecture Videos",
      taskSubmitTooltip: "Submit Task",
      taskTooltip: "Task",
      mySubmissionTooltip: "My Submission",
      uploadTaskTooltip: "Upload Task",
      deadlinePassedTooltip: "Deadline Passed",
      taskDegree: "Task Degree",
      taskFeedback: "Task Feedback",
      driveTooltip: "Drive",
      lectureTasksTooltip: "Lecture Tasks",
      lectureProjectsTooltip: "Lecture Projects",
      lectureAdditionalMaterialsTooltip: "Lecture Additional Materials",
      lectureContentTooltip: "Lecture Content",
    },
    videos: {
      noData: "No Videos Found",
      video: "Video",
    },
    rounds: {
      attendanceRate: "Attendance Rate",
      taskDegreeRate: "Task Degree Rate",
      meetingLink: "Meeting Link",
      viewDetails: "View Details",
      viewPlan: "View Course Plan",
      lecturesCount: "Lessons",
      types: {
        online: "Online",
        offline: "Offline",
        hybrid: "Hybrid",
      },
      status: {
        active: "Active",
        finished: "Finished",
      },
    },
  },

  confirm: {
    delete: {
      primary: "Delete",
      secondary: "Cancel",
      message: "This action cannot be undone",
      title: "Delete?",
    },
    discardChanges: {
      primary: "Discard",
      secondary: "Keep Editing",
      message: "This will delete all edits since you last saved",
      title: "Discard unsaved changes?",
    },
    logout: {
      primary: "Logout",
      secondary: "Cancel",
      message: "Are you sure you want to logout?",
      title: "Logout",
    },
  },

  noMessages: {
    no: "No",
    data: "Data",
    todaysMeetings: "Meetings Today",
    feedbacks: "Feedbacks",
    projects: "Projects",
    tickets: "Tickets",
    courses: "Courses",
    surveys: "Surveys",
    videos: "Videos",
    materials: "Materials",
    freeMaterials: "Free Materials",
    reviews: "Reviews",
  },

  breadCrumbs: {
    enrolledCourses: "Enrolled Courses",
    videos: "Videos",
  },

  audioRecorder: {
    noSupport: "Your browser does not support the audio element.",
  },
  notifications: {
    drop: {
      title: "Notifications",
      noData: "No Notifications",
    },
  },

  common: {
    back: "Back",
    completed: "Completed",
    noData: "No Data",
    course: "Course",
    chapter: "Chapter",
    lesson: "Lesson",
  },
}
